<div class="floader text-center p-4 mx-auto">
  <img
    class="mt-5 mx-5 box2 bradd bo3-cmain"
    width="80px"
    src="assets/fingz.png"
    alt=""
  />
</div>
